var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c("v-col", { attrs: { cols: "12" } }, [
        _c("h1", { staticClass: "title primary--text mb-4" }, [
          _vm._v(" ระบบสร้างบาร์โค้ดอัตโนมัติ "),
          _c("span", { staticClass: "ml-4 caption red--text" }, [
            _vm._v(
              " *ระบบจะทำการสร้างบาร์โค้ดให้กับสินค้าที่ยังไม่มีบาร์โค้ดเท่านั้น "
            ),
          ]),
        ]),
        _c("p", { staticClass: "mb-8" }, [
          _vm._v(
            " EAN-8: เลข 8 หลัก, EAN-13: เลข 13 หลัก, CODE-128: ตัวอักษร (ระบบจะใช้รหัสสินค้า/สินค้าย่อยเป็นบาร์โค้ด) "
          ),
        ]),
        _c(
          "div",
          [
            _c("div", { staticClass: "mb-2" }, [
              _c("label", { attrs: { for: "barcode-type" } }, [
                _vm._v(" ประเภทของบาร์โค้ดที่ต้องการสร้าง "),
              ]),
              _c("span", { staticClass: "text-error" }, [_vm._v("*")]),
            ]),
            _c("SelectBarcodeFormat", {
              model: {
                value: _vm.barcodeFormat,
                callback: function ($$v) {
                  _vm.barcodeFormat = $$v
                },
                expression: "barcodeFormat",
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "v-col",
        {
          staticClass:
            "d-flex flex-column flex-sm-row justify-sm-space-between gap-2",
          attrs: { cols: "12" },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex flex-column flex-sm-row align-sm-center" },
            [
              _c("h1", { staticClass: "title primary--text mr-4" }, [
                _vm._v(" เลือกสินค้าที่ต้องการสร้างบาร์โค้ด "),
              ]),
              _c("BarcodeFilter", {
                attrs: { value: _vm.filter },
                on: {
                  onFilter: function ($event) {
                    return _vm.handleFilter($event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c("v-text-field", {
                attrs: {
                  value: _vm.searchText,
                  placeholder: "ค้นหาสินค้า",
                  "append-icon": "mdi-magnify",
                  dense: "",
                  outlined: "",
                  "hide-details": "",
                },
                on: {
                  input: function ($event) {
                    return _vm.setSearchTextDebounce($event)
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm.productList
        ? _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("ProductTableBarcode", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.productList.nodes,
                  "total-pages": _vm.productList.pagesCount,
                  loading: _vm.$apollo.queries.productList.loading,
                  page: _vm.page,
                  "per-page": _vm.perPage,
                },
                on: {
                  onPageChange: function ($event) {
                    return _vm.handlePageChange($event)
                  },
                },
                model: {
                  value: _vm.selected,
                  callback: function ($$v) {
                    _vm.selected = $$v
                  },
                  expression: "selected",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c("BarcodeCreateDialog", {
            attrs: {
              "item-ids": _vm.itemsSelectedIds,
              "barcode-format": _vm.barcodeFormat,
            },
            on: {
              onSuccess: function ($event) {
                return _vm.clearItemsSelected()
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }